<template>
    <form @submit.prevent="">
        <input class="u-full-width" type="text" name="name" placeholder="Je naam" v-model="name"
               :class="{'error': $v.name.$error}">
        <input class="u-full-width" type="email" name="email" placeholder="Je email" v-model="email"
               :class="{'error': $v.email.$error}">
        <input class="u-full-width" type="text" name="phone" placeholder="Je telefoonnummer" v-model="phone"
               :class="{'error': $v.phone.$error}">
        <input class="u-full-width" type="text" name="the_natures_gold" placeholder="gold" v-model="honey">
        <button class="button-primary" type="submit" @click="send_application"
                :disabled="sending">
            Solliciteren
        </button>
        <span v-show="$v.$invalid && tried" class="error_message" key="error_message">
            Sommige velden zijn verplicht
        </span>
        <span v-show="send" class="success_message" key="success_message">
            Formulier verstuurd
        </span>
    </form>
</template>

<script>
    const Ajax = require('simple-ajax');
    import {required} from "vuelidate/lib/validators";

    export default {
        props: {
            vacancy: {
                // Recommended to also define the types in the cloud function
                type: String,
                required: true
            }
        },
        data() {
            return {
                name: "",
                email: "",
                phone: "",
                honey: "",
                sending: false,
                send: false,
                tried: false,

                token: null,
            }
        },
        validations: {
            name: {required},
            email: {required},
            phone: {required},
        },
        methods: {
            send_application() {
                const self = this;
                if (self.sending) {
                    return false;
                }

                self.tried = true;

                self.$v.$touch();
                if (self.$v.$invalid) {
                    return;
                }

                if (self.honey) {
                    return;
                }

                self.sending = true;
                self.send = false;

                const ajax = new Ajax({
                    url: "https://us-central1-swbase-website.cloudfunctions.net/applyJob",
                    method: 'POST',
                    data: JSON.stringify({
                        name: self.name,
                        email: self.email,
                        phone: self.phone,
                        job_type: self.vacancy || "open",
                        token: self.token,
                    })
                });

                ajax.on('success', response => {
                    self.name = "";
                    self.email = "";
                    self.phone = "";
                    self.honey = "";
                    self.sending = false;
                    self.send = true;
                    self.tried = false;

                    self.run_captcha();

                    self.$v.$reset();
                });

                ajax.send();
            },
            run_captcha() {
                const self = this;
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute('6LdDIXkUAAAAAEvXDmwdpxc0TzHl5nOhx7ruvGKv', {action: 'vacancy'})
                        .then(token => {
                            self.token = token;
                        });
                });
            }
        },
        mounted() {
            const self = this;
            self.run_captcha();
        }
    }
</script>

<style scoped>
    input {
        font-size: 14px;
    }
</style>